import { faArrowsTurnToDots, faFlask, faBoxOpen, faComment, faNoteSticky, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { use, useEffect, useContext, useState } from 'react';
import { Spinner, Accordion, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import usePrivileges from '../../../Auth/usePrivileges';
import { LotDetailContext } from '../../../Contexts/LotDetailContext';
import { UserPreferencesContext } from '../../../Contexts/UserPreferencesContext';
import { Section } from '../../../Types/Section';
import GradingCommentsSection from '../LotDetailsComponents/GradingCommentsSection';
import LabResultsSection from '../LotDetailsComponents/LabResultsSection';
import PackagesSection from '../LotDetailsComponents/PackagesSection/PackagesSection';
import QIRSection_QIRMS from '../LotDetailsComponents/QIRSection_QIRMS';
import WarningsSection from '../LotDetailsComponents/WarningsSection';
import RelatedLotsSection from '../LotDetailsComponents/RelatedLotsSection';
import LotDetailSummary from '../LotDetailsComponents/Summary';
import { LotDetailSection } from '../LotDetailSection';
import { SectionNavigation } from '../SectionNavigation';

function LotDetails_BRPP_G_LINE_HoldingLot() {
    const {
        lotDetail,
        lotDetail: {
            packages
        }
    } = useContext(LotDetailContext);
    const { userPreferences, loading: userPreferencesLoading, setActiveSections } = use(UserPreferencesContext);
    const [loading, setLoading] = useState(false);

    const sections: Section[] = [
        { name: 'warnings', title: 'LotDetails.Warnings.Title', icon: faTriangleExclamation, component: <WarningsSection /> },
        { name: 'QIRMSqirs', title: 'LotDetails.QIRs.Title', icon: faNoteSticky, component: <QIRSection_QIRMS showCreateQIRButton={true} /> },
        { name: 'relatedLots', title: 'LotDetails.RelatedLots.Title', icon: faArrowsTurnToDots, component: <RelatedLotsSection /> },
        { name: 'labresults', title: 'LotDetails.LabResults.Title', titleSuffix: `${lotDetail.labResults?.length ?? ""}`, icon: faFlask, component: <LabResultsSection showSampleGrade={true} /> },
        { name: 'packages', title: 'LotDetails.Packages.Title', titleSuffix: `${packages?.length ?? ""}`, icon: faBoxOpen, component: <PackagesSection packagesCanBeEdited={true} /> },
        { name: 'gradingcomments', title: 'LotDetails.GradingComments.Title', icon: faComment, component: <GradingCommentsSection /> },
    ];

    const [defaultActiveSections, setDefaultActiveSections] = useState(sections.map(section => section.name));
    useEffect(() => {
        if (userPreferences?.lotDetail?.activeSections) {
            setDefaultActiveSections(userPreferences?.lotDetail?.activeSections);
        }
    }, [userPreferences?.lotDetail?.activeSections]);

    if (userPreferencesLoading) {
        return (
            <div className="d-flex justify-content-center mb-3">
                <Spinner animation="border" />
            </div>
        );
    }

    return (lotDetail &&
        <>
            <LotDetailSummary setLoading={setLoading} />

            <SectionNavigation sections={sections} />

            <Accordion activeKey={defaultActiveSections} onSelect={(eventKey) => setActiveSections(eventKey as string[])} alwaysOpen className="mb-2">
                {sections.map(section =>
                    <LotDetailSection
                        key={section.name}
                        name={section.name}
                        icon={section.icon}
                        title={section.title}
                        titleSuffix={section.titleSuffix}
                        component={section.component} />)
                }
            </Accordion>
        </>
    );
}

export default LotDetails_BRPP_G_LINE_HoldingLot;